/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkkindtickets3Inputs */

const en_ticketlinkkindtickets3 = /** @type {(inputs: Ticketlinkkindtickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket shop`)
};

const de_ticketlinkkindtickets3 = /** @type {(inputs: Ticketlinkkindtickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketshop`)
};

/**
* | output |
* | --- |
* | "Ticket shop" |
*
* @param {Ticketlinkkindtickets3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkkindtickets3 = /** @type {((inputs?: Ticketlinkkindtickets3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkkindtickets3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkkindtickets3(inputs)
	return de_ticketlinkkindtickets3(inputs)
});
export { ticketlinkkindtickets3 as "ticketLinkKindTickets" }